
export const initDashTiles = (dash_tiles) => ({
    type:"DASHTILE_INIT",
    dash_tiles,
});